import { zoomIn, zoomOut } from "cssinjs-animations"

const drawerWidth = 350

const styles = theme => ({
  "@keyframes zoomIn": zoomIn,
  "@keyframes zoomOut": zoomOut,
  drawer: {
    width: "100%",
    maxWidth: drawerWidth,
  },
  drawerOpen: {
    boxShadow:
      "0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)",
  },
  messageDrawerButtonWrapper: {
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 1301,
    transition: theme.transitions.create("right", {
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  messageDrawerButtonWrapperOpen: {
    right: 20 + drawerWidth,
  },
  messageDrawerButtonBadge: {
    top: "initial",
    bottom: 40,
    zIndex: 1301,
    right: -8,
  },
  messageDrawerButtonBadgeZoomIn: {
    animationName: "zoomIn",
    animationDuration: theme.transitions.duration.enteringScreen,
  },
  messageDrawerButtonBadgeZoomOut: {
    animationName: "zoomOut",
    animationDuration: theme.transitions.duration.shortest,
    animationFillMode: "forwards",
  },
  avatarImage: {
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "50%",
  },
  speedDialActionButton: {
    "&:hover $closeIconWrapper": {
      opacity: 1,
    },
  },
  actionBadgeRoot: {
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closeIconWrapper: {
    opacity: "0",
    position: "absolute",
    top: "-15px",
    right: "-15px",
    zIndex: "2",
    color: theme.palette.grey[800],
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&:after": {
      content: "''",
      backgroundColor: "#fff",
      height: "20px",
      width: "20px",
      position: "absolute",
      top: "4px",
      right: "4px",
      borderRadius: "50%",
      display: "block",
      zIndex: "0",
    },
  },
  closeIcon: {
    width: "30px",
    height: "30px",
    position: "relative",
    zIndex: "1",
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  flexCenter: {
    justifyContent: "center",
  },
  mainArea: {
    flexGrow: 2,
    display: "flex",
    flexDirection: "column",
  },
  inputArea: {
    height: 65,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  input: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
    position: "relative",
  },
  mediaContent: {
    position: "absolute",
    bottom: theme.spacing(1.5),
    left: theme.spacing(2),
    color: "#fff",
  },
  cardContentRoot: {
    paddingTop: 4,
  },
  cardHeadline: {
    fontSize: "1.3em",
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    textOverflow: "ellipsis",
    marginBottom: 0,
  },
  primaryPlace: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
  },
  rating: {
    color: theme.palette.grey[500],
    display: "flex",
    alignItems: "center",
  },
  ratingIcon: {
    fontSize: "0.8em",
    marginRight: theme.spacing(1 / 3),
  },
  starIcon: {
    color: theme.palette.primary.main,
  },
  ratingWrapper: {
    display: "flex",
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: "auto",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  chipWrapper: {
    display: "flex",
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontSize: "0.7125rem",
    height: 25,
    marginRight: theme.spacing(1),
  },
  chipDeleteIcon: {
    color: "rgba(255, 255, 2555, 0.56)",
    width: "0.8em",
  },
  spinnerWrapper: {
    padding: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
  },
  messagesWrapper: {
    padding: "8px 20px 0",
    justifySelf: "center",
    alignSelf: "center",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflow: "auto",
  },
  message: {
    display: "flex",
    flexDirection: "column",
  },
  messageTime: {
    color: theme.palette.text.hint,
    fontSize: 10,
    marginBottom: theme.spacing(1 / 2),
  },
  messageBubbleWrapper: {
    display: "flex",
  },
  messageBubble: {
    fontSize: 16,
    lineHeight: "1.4",
    margin: "1px 0",
    padding: "8px 17px 6px 13px",
    maxWidth: 380,
    position: "relative",
    borderRadius: 18,
    marginBottom: theme.spacing(1),
    display: "inline-block",
    "&:after": {
      position: "absolute",
      content: '""',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: -1,
    },
  },
  fromMe: {
    alignSelf: "flex-end",
    "& $messageBubbleWrapper": {
      justifyContent: "flex-end",
    },
    "& $messageBubble": {
      color: "white",
      backgroundColor: "#1084ff",
      "&:after": {
        background: `url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='15.515px' height='17.5px' viewBox='32.485 17.5 15.515 17.5' enable-background='new 32.485 17.5 15.515 17.5'><path fill='#1084FF' d='M48,35c-7-4-6-8.75-6-17.5C28,17.5,29,35,48,35z'/></svg>") right bottom no-repeat`,
        right: -6,
      },
    },
  },
  toMe: {
    alignSelf: "flex-start",
    "& $messageBubble": {
      color: "black",
      backgroundColor: "#E5E5EA",
      "&:after": {
        background: `url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='15.515px' height='17.5px' viewBox='32.484 17.5 15.515 17.5' enable-background='new 32.484 17.5 15.515 17.5'><path fill='#E5E5EA' d='M38.484,17.5c0,8.75,1,13.5-6,17.5C51.484,35,52.484,17.5,38.484,17.5z'/></svg>") left bottom no-repeat`,
        left: -6,
      },
    },
  },
  noChatsMessage: {
    textAlign: "center",
  },
  noMessages: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
  },
})

export default styles
